import React, { useEffect, useState } from 'react'
import { ViewStyle } from 'react-native'
import { useStores, setPageTitle, Badge } from '@trivie/core'
import { color, LevelProgress, UserBadges } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'
import { DateTime } from 'luxon'
import { Instance, cast } from 'mobx-state-tree'
import { CertsMedals } from '@trivie/ui-mobile/components/certs-medals-list'

export const AchievementsScreen = observer(() => {
  const { userStore, badgeStore } = useStores()
  const {
    getUserLevelAndPoints,
    getCertsMedalsForUser,
    userCertsMedals,
    levelAndPoints,
    user,
    enterpriseTier,
    setSplashNotifications,
  } = userStore
  const { getBadgesForUser, badges } = badgeStore

  const [loadingBadges, setLoadingBadges] = useState(true)
  const [loadingLevels, setLoadingLevels] = useState(true)

  const gaterDataForTabAchievements = () => {
    if (user) {
      setLoadingBadges(true)
      setLoadingLevels(true)
      if (enterpriseTier) {
        getCertsMedalsForUser(user.id)
        getBadgesForUser(user.id).then(() => {
          setLoadingBadges(false)
        })
      }
      getUserLevelAndPoints(
        user.id,
        '1970-01-01 04:00:00',
        DateTime.local().plus({ days: 1 }).toFormat('yyyy-MM-dd HH:mm'),
      ).then(() => {
        setLoadingLevels(false)
      })
    }
  }

  useEffect(() => {
    gaterDataForTabAchievements()
    setPageTitle(`Profile - ${process.env.REACT_APP_SITE_TITLE}`)
  }, [])

  const goToBadge = (badge: Instance<typeof Badge>) => {
    setSplashNotifications(
      cast([
        {
          notification_type: 'badge',
          badge_icon_url: badge.icon_url,
          label: badge.label,
          description: badge.description,
          locked: !badge.awarded_at,
          hide_celebration: true,
        },
      ]),
    )
  }

  return (
    <>
      {user?.workspace_settings?.user_levels_enabled && (
        <div style={{ margin: 2 }}>
          <LevelProgress
            base="Profile"
            total_points={levelAndPoints?.points.total_points ?? 0}
            cardStyle={LEVELS}
            loading={loadingLevels}
            levelAndPoints={levelAndPoints}
            buttonTextStyle={{ color: color.black } as ViewStyle}
            buttonStyle={{
              borderColor: color.orange,
              backgroundColor: '#F3B14E',
              width: 24,
              height: 24,
            }}
            progressStyle={{ backgroundColor: '#F3B14E20' }}
          />
        </div>
      )}
      {enterpriseTier && <CertsMedals data={userCertsMedals} />}
      <UserBadges goToBadge={goToBadge} loading={loadingBadges} badges={badges} />
    </>
  )
})

/**
 * Styling
 */
const LEVELS: ViewStyle = {
  borderWidth: 2,
  borderColor: '#F3F2F1',
  marginBottom: 16,
}
